import { record } from 'rrweb';
import * as siteAnalyticsApi from '@/api/siteAnalytics';
import { getSessionId } from '@/utils/siteAnalytics';

const FLUSH_INTERVAL_MS = 10000;
const MAX_BUFFER_SIZE = 200;

let stopFn = null;
const eventBuffer = [];
let flushTimer = null;
let isOnAdminPage = false;

function flushEvents() {
  if (!eventBuffer.length) return;

  const sessionId = getSessionId();
  const batch = eventBuffer.splice(0, eventBuffer.length);

  siteAnalyticsApi.saveRecording({
    session_id: sessionId,
    events: batch,
  }).catch(() => {});
}

function beginCapture() {
  if (stopFn) return;

  stopFn = record({
    emit(event) {
      eventBuffer.push(event);
      if (eventBuffer.length >= MAX_BUFFER_SIZE) {
        flushEvents();
      }
    },
    maskInputOptions: {
      password: true,
    },
    maskInputSelector: '.p-password input, [type="password"]',
    blockSelector: '[data-rrweb-block]',
    sampling: {
      mousemove: 50,
      mouseInteraction: true,
      scroll: 150,
      input: 'last',
    },
  });

  if (!flushTimer) {
    flushTimer = setInterval(flushEvents, FLUSH_INTERVAL_MS);
  }

  window.addEventListener('beforeunload', flushEvents);
}

function pauseCapture() {
  if (stopFn) {
    stopFn();
    stopFn = null;
  }
  flushEvents();
}

export function setupRecording(router) {
  router.afterEach((to) => {
    const entering = to.path.startsWith('/admin');
    if (entering && !isOnAdminPage) {
      pauseCapture();
      isOnAdminPage = true;
    } else if (!entering && isOnAdminPage) {
      isOnAdminPage = false;
      beginCapture();
    }
  });

  if (!window.location.pathname.startsWith('/admin')) {
    beginCapture();
  } else {
    isOnAdminPage = true;
  }
}

export function stopRecording() {
  pauseCapture();
  if (flushTimer) {
    clearInterval(flushTimer);
    flushTimer = null;
  }
  window.removeEventListener('beforeunload', flushEvents);
}
